export enum ReportType {
    Role = 'role',
    Team = 'team',
    Individual = 'individual',
}
